export const AnagraficaPreferenze = {
    vendo: 'VENDO',
    acquisto: 'ACQUISTO',
    offroAffitto: 'OFFRO_AFFITTO',
    cercoAffitto: 'CERCO_AFFITTO'
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/anagrafica-preferenze.ts